export default (key, location) => {
  const getValue = fullKey => {
    let value = defaults[fullKey];
    if (typeof window !== "undefined") {
      value =
        window.config && window.config[fullKey] !== undefined
          ? window.config[fullKey]
          : defaults[fullKey];
    }
    return value;
  };
  const regionEnvName = `${key}${location ? `_${location}` : ""}`;
  const globalEnvName = key;
  const regionValue = getValue(regionEnvName);
  return regionValue ? regionValue : getValue(globalEnvName);
};

const defaults = {
  API_URL: "http://localhost:3000/api/",
  TICKETING_URL: "http://localhost:8080",
  WEBSITE_URL: "http://localhost:7070",
  CONSOLE_URL: "http://localhost:3001",
  WORLD_PAY_CHECKOUT_ID: "6124a59f-a0fb-4ec5-aa14-4c19b9ca2995",
  WORLD_PAY_API_URL: "https://try.access.worldpay.com",
  BPOINT_API_URL: "https://www.bpoint.com.au/webapi/v3/",
  SENTRY_ERROR_ACCESS_APP: null,
  NODE_ENV: "staging",
  DEV: true,
  PAYPAL_ENV: "production",
  STRIPE_APK_KEY: "pk_test_xtsRcoIILJ6EWSxRgSEgnosm",
  STRIPE_PAYMENTS_APK_KEY: "pk_test_ypnO6rkaWXTx2279MA2P8evA",
  STRIPE_PAYMENTS_APK_KEY_NZ: "pk_test_ypnO6rkaWXTx2279MA2P8evA",
  CURRENCY: "AUD",
  ZIPMONEY_LIBARY_URL:
    "https://static.zipmoney.com.au/checkout/checkout-v1.min.js",
  ZIPMONEY_ENV: "sandbox",
  ORDER_COMPLETE_TIME: 20,
  GOOGLE_API_KEY: "AIzaSyBrLKaAEokK10u3KCRKI0WJyXUN6iAT6AI",
  FILESTACK_KEY: "AeJa0mS9cRHyQaj6WeE3yz",
  REDIRECT_TIME: 7000,
  TILL_PUBLIC_INTEGRATION: "ga4TB41hkFyCOh8LsGr0"
};
